<template>
	<div class="con-1334 box-white mt-30px success">
		<div class="success__header">
			<img src="/img/frontend/calc/icon/check.svg" alt="Sikeres rögzítés" />
			<h1>Sikeres rögzítés</h1>

			<p>
				Tisztelt Ügyfelünk!
				<br />
				Ön sikeresen rögzítette Minősített Fogyasztóbarát Otthonbiztosítását, az ajánlatot továbbítottuk a
				biztosító társasághoz!
			</p>
		</div>
		<div class="success__info">
			<h3>A biztosítási ajánlat adatai:</h3>
			<ul>
				<li>
					Biztosító:
					<b>{{ computedData.insurer_name }}</b>
				</li>
				<li>
					Kockázatviselés helye:
					<b>{{ computedData.risk_place }}</b>
				</li>
				<li>
					Ajánlatszám:
					<b>{{ computedData.offer_code }}</b>
				</li>
				<li>
					Eurorisk szerződésazonosító:
					<b>{{ computedData.offer_number }}</b>
				</li>
				<li>
					A biztosítás éves díja:
					<b>{{ computedData.annual_fee | toCurrency }}</b>
				</li>
				<li>
					Kockázatviselés kezdete:
					<b>{{ computedData.start_of_risk }}</b>
				</li>
			</ul>
		</div>
		<div class="success__footer">
			<p>
				A biztosítási dokumentumokat az alábbiakban megtekintheti, azokat elküldtük az Ön által megadott e-mail
				címre is:
			</p>
			<div class="files">
				<a :href="computedData.brokerage_contract_pdf" target="_blank">Alkuszi megbízás</a>
				|
				<a :href="computedData.insurer_offer_pdf" target="_blank">Biztosítási ajánlat</a>
				|
				<a :href="computedData.aszf_pdf" target="_blank">Biztosítói ÁSZF</a>
				|
				<a :href="computedData.product_pdf" target="_blank">Termékismertető</a>
                <template v-if="!computedIsNewContract">
                    |
                    <a :href="computedData.termination" target="_blank">Felmondás</a>
                    |
                    <a :href="computedData.termination_authorization" target="_blank">Felmondás meghatalmazás</a>
                </template>
			</div>

			<p>Kármentes éveket kívánunk!</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
	computed: {
		...mapGetters('contracting', ['getOfferResponse']),
		...mapGetters(['getCalculation', 'getQuestionAnswers']),
        computedIsNewContract() {
            return this.getQuestionAnswers?.isNewContract;
        },
		computedData() {
			return {
				insurer_name: this.getOfferResponse.insurer_name ?? null,
				offer_code: this.getOfferResponse.offer_code ?? null,
				offer_number: this.getOfferResponse.offer_number ?? null,
				annual_fee: this.getOfferResponse.annual_fee ?? null,
				start_of_risk: moment(this.getCalculation.start_of_risk).format('yyyy.MM.DD.') ?? null,
				risk_place: this.getCalculation.real_estate?.name ?? null,
				insurer_offer_pdf:
					`/api/pdf/download/generated/${this.getOfferResponse.contract_id}/insurer_offer_pdf` ?? null,
				brokerage_contract_pdf:
					`/api/pdf/download/generated/${this.getOfferResponse.contract_id}/brokerage_contract_pdf` ?? null,
				aszf_pdf: `/api/pdf/download/insurer/${this.getOfferResponse.insurer_slug}/aszf/${this.getCalculation.start_of_risk}` ?? null,
				product_pdf: `/api/pdf/download/insurer/${this.getOfferResponse.insurer_slug}/term_ism/${this.getCalculation.start_of_risk}` ?? null,
                termination: `/api/pdf/download/generated/${this.getOfferResponse.contract_id}/old_contract_termination_pdf` ?? null,
                termination_authorization: `/api/pdf/download/generated/${this.getOfferResponse.contract_id}/old_contract_termination_authorization_pdf` ?? null,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.success {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-left: 0;
	padding-right: 0;

	p {
		font-size: 16px;
		line-height: 24px;
	}

	&__header {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 65px;
			height: 49px;
			border: 10px solid #219653;
			border-radius: 100%;
			padding: 30px 23px;
			margin-top: 30px;
            box-sizing: unset;
		}

		h1 {
			font-family: Arial;
			font-style: normal;
			font-weight: bold;
			font-size: 54px;
			line-height: 40px;
			color: #1f2835;
		}
	}

	&__info {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: rgba(237, 251, 255, 0.5);
		width: 100%;
		padding-bottom: 30px;

		h3 {
			font-family: Arial;
			font-style: normal;
			font-weight: normal;
			font-size: 16px;
			line-height: 24px;
			color: #1f2835;
		}

		ul {
			padding: 0;
			margin: 0;
			display: flex;
			flex-wrap: wrap;
			list-style-type: none;
			width: 70%;

			li {
				width: 50%;
				font-size: 16px;
				line-height: 24px;
			}
		}
	}

	&__footer {
		margin-top: 20px;
		text-align: center;

		a {
			font-weight: 700;
			text-transform: uppercase;

			&:hover {
				text-decoration: underline;
			}
		}

		p:first-child {
			margin-bottom: 5px;
		}

		p:last-child {
			margin: 30px 0;
		}
	}
}
</style>
